import { Component, OnInit } from '@angular/core';
import { IMyDpOptions } from 'mydatepicker';

import { Dados } from './dados';
import { RelatorioService } from './relatorio.service';

@Component({
  selector: 'app-relatorios',
  templateUrl: './relatorios.component.html',
  styleUrls: ['./relatorios.component.css'],
  providers: [
    RelatorioService
  ]
})
export class RelatoriosComponent implements OnInit {
  dados: Dados;

  // variaveis para componente do calendario
  public hoje = new Date();
  public amanha = new Date();

	public myDatePickerOptionsInicial: IMyDpOptions = {
        dayLabels: {su: "Dom", mo: "Seg", tu: "Ter", we: "Qua", th: "Qui", fr: "Sex", sa: "Sab"},
		    monthLabels: { 1: "Jan", 2: "Fev", 3: "Mar", 4: "Abr", 5: "Mai", 6: "Jun", 7: "Jul", 8: "Ago", 9: "Set", 10: "Out", 11: "Nov", 12: "Dez" },
		    dateFormat: "dd/mm/yyyy",
		    todayBtnTxt: "Hoje",
		    firstDayOfWeek: "su",
		    sunHighlight: true,
        markCurrentDay: true,
        disableSince: {year: this.hoje.getFullYear(), month: this.hoje.getMonth()+1, day: this.hoje.getDate()},
        enableDays: [{year: this.hoje.getFullYear(), month: this.hoje.getMonth()+1, day: this.hoje.getDate()}]
    };

    public myDatePickerOptionsFinal: IMyDpOptions = {
          dayLabels: {su: "Dom", mo: "Seg", tu: "Ter", we: "Qua", th: "Qui", fr: "Sex", sa: "Sab"},
  		    monthLabels: { 1: "Jan", 2: "Fev", 3: "Mar", 4: "Abr", 5: "Mai", 6: "Jun", 7: "Jul", 8: "Ago", 9: "Set", 10: "Out", 11: "Nov", 12: "Dez" },
  		    dateFormat: "dd/mm/yyyy",
  		    todayBtnTxt: "Hoje",
  		    firstDayOfWeek: "su",
  		    sunHighlight: true,
          markCurrentDay: true,
          disableSince: {year: this.hoje.getFullYear(), month: this.hoje.getMonth()+1, day: this.hoje.getDate()},
          enableDays: [{year: this.hoje.getFullYear(), month: this.hoje.getMonth()+1, day: this.hoje.getDate()}]
      };

	public maskdataInicial: any = ""; //{ date: { year: 2018, month: 10, day: 9 } };
  public maskdataFinal: any = "";

  constructor(private relatorioService: RelatorioService) {
    this.dados = new Dados();
  }

  salvar(): void {
    this.relatorioService.getDados(this.dados)
      .then(() => {this.goBack();}, () => {});
  }

  atualizaDataHora() {
		var dtInicial  = "";
    var dtFinal  = "";

		if (typeof(this.maskdataInicial.date) != "undefined") {
			dtInicial = this.maskdataInicial.date.day+"/"+this.maskdataInicial.date.month+"/"+this.maskdataInicial.date.year;
		}

    if (typeof(this.maskdataFinal.date) != "undefined") {
			dtFinal = this.maskdataFinal.date.day+"/"+this.maskdataFinal.date.month+"/"+this.maskdataFinal.date.year;
		}

		this.dados.dataInicial = dtInicial;
    this.dados.dataFinal = dtFinal;

		//console.log(this.dados);

	}

  goBack(): void {
    this.maskdataInicial = "";
    this.maskdataFinal = "";
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/relatorios/relatorios.component.ts